import { render } from "./avatar-item.vue?vue&type=template&id=9d39fe38&ts=true"
import script from "./avatar-item.vue?vue&type=script&lang=ts"
export * from "./avatar-item.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\src\\BusinessLuchs_CRM\\frontend-dispatcher\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__